import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils"; 
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Grid } from "@mui/material";
import Bubble from "@mui/icons-material/BubbleChart";
import "./Client.css"

const Clients = [
  {
    id: 1,
    name: "John Smith",
    profession: "CEO",
    company: "Microsoft",
    review:
      "Putting together a website is a task, finding the right individual or company is even more complex. I did my search around looking for this particular company that has the ability to create, design and optimized my web site. Thanks God I meet Gus at MiamiWeb, not only they have great taste in design but they can guide you through the process and beyond.",
    image:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8bWVuc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 2,
    name: "Drabid rodis",
    profession: "Programmer",
    company: "UPS",
    review:
      "Excellent, working with web designer express was great.  Thanks to their knowledge and determination our website looks great and functions really good.  I am recommend anyone that is looking for a custom website to give them a call and speak to Gus, he will guide you to the right direction.",
    image:
      "https://media.istockphoto.com/photos/smiling-mixed-race-mature-man-on-grey-background-picture-id1319763895?b=1&k=20&m=1319763895&s=170667a&w=0&h=jhqKyg62cQVZ-NjDQjpcenCdHDrprkN4caRjk4K76E8=",
  },
  {
    id: 3,
    name: "Moshi khan ",
    profession: "Product Manager",
    company: "Alibaba",
    review:
      "Our company has been working with Web Design Express since 2009. Web Design Express has evolved in a very positive way through the years. We recently worked with them to update our website. We have been mainly working with Edi. We are beyond pleased with Edi's impeccable service. He is extremely helpful in guiding us through the whole process. He is very knowledgeable. He pays close attention to details. He is also very patient in training us on how to use the new administration system. Overall, we are very pleased with Web Design Express.",
    image:
      "https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWVuc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
];

const Client = () => {
  const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = Clients.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div>
      <div>
        <h1 className="client-about"> My Clients</h1>
        <p>
          It is a long established fact that a reader will be of a page when
          established fact looking at its layout.
        </p>
      </div>


      <div className="client-review-container">
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {Clients.map((review) => (
            <Grid container spacing={2}>
              <Grid className="client-review">
                <img
                  src={review?.image}
                  className="client-images"
                  alt="client-images"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                     {review?.name}
                  </Typography>
                  <p className="client-about-me">
                    {review?.review}
                  </p>
                  <p> {review?.profession} <b>-{review.company}</b> </p>

                  <p  style={{ display: 'inline' }}>
                    <Bubble
                      style={{
                        width: "50px",
                        height: "50px",
                        color: "tomato",
                        left: "44%",  
                        position: "relative",
                        display: "inline"
                      }}
                    ></Bubble>
                  </p>

                </CardContent>


              </Grid>
            </Grid>
          ))}
        </AutoPlaySwipeableViews>
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
            >
              Next
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Back
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default Client;
